/**
 * WhatsApp normalizado: somente dígitos, com DDI 55 (plano, seção 17.3).
 * Aceita o que a pessoa digitar: "(92) 99123-4567", "92991234567", "+55 92 9 9123 4567".
 */
export function normalizeWhatsapp(input: string | null | undefined): string | null {
  if (!input) return null;
  let digits = input.replace(/\D/g, '');
  if (digits.length === 0) return null;
  // remove zero de discagem de longa distância: 0 92 99123-4567, 0xx92...
  digits = digits.replace(/^0+/, '');
  if (digits.length === 10 || digits.length === 11) return `55${digits}`;
  if ((digits.length === 12 || digits.length === 13) && digits.startsWith('55')) return digits;
  // Número estrangeiro com DDI: mantém como veio
  if (digits.length >= 10 && digits.length <= 15) return digits;
  return null;
}

export function isValidWhatsapp(input: string | null | undefined): boolean {
  return normalizeWhatsapp(input) !== null;
}

/** "5592991234567" -> "(92) 99123-4567" */
export function formatWhatsapp(normalized: string | null | undefined): string {
  if (!normalized) return '';
  const d = normalized.replace(/\D/g, '');
  if (d.startsWith('55') && (d.length === 12 || d.length === 13)) {
    const ddd = d.slice(2, 4);
    const rest = d.slice(4);
    const head = rest.length === 9 ? rest.slice(0, 5) : rest.slice(0, 4);
    const tail = rest.slice(head.length);
    return `(${ddd}) ${head}-${tail}`;
  }
  return `+${d}`;
}

/** Link do WhatsApp com mensagem pronta. Sem número abre a escolha de contato. */
export function whatsappUrl(normalized: string | null | undefined, text: string): string {
  const encoded = encodeURIComponent(text);
  if (!normalized) return `https://wa.me/?text=${encoded}`;
  return `https://wa.me/${normalized.replace(/\D/g, '')}?text=${encoded}`;
}

/**
 * Máscara do telefone do Brasil enquanto a pessoa digita: "92991234567" -> "(92) 99123-4567";
 * fixo com 8 dígitos: "(92) 3234-5678". Colou com +55 ou com o zero da longa distância: tira.
 * Começou com "+" e outro DDI: deixa o número estrangeiro como veio (só dígitos).
 */
export function maskPhoneBr(input: string | null | undefined): string {
  if (!input) return '';
  const raw = input.trim();
  let d = raw.replace(/\D/g, '');
  if (raw.startsWith('+') && !d.startsWith('55')) return `+${d.slice(0, 15)}`;
  if (raw.startsWith('+') || (d.startsWith('55') && d.length > 11)) d = d.slice(2);
  d = d.replace(/^0+/, '').slice(0, 11);
  if (d.length === 0) return '';
  if (d.length <= 2) return `(${d}`;
  const ddd = d.slice(0, 2);
  const rest = d.slice(2);
  if (rest.length <= 4) return `(${ddd}) ${rest}`;
  const head = rest.length === 9 ? rest.slice(0, 5) : rest.slice(0, 4);
  return `(${ddd}) ${head}-${rest.slice(head.length)}`;
}
